'use client';
import React, { ReactNode } from 'react';
import { Link } from '@mui/material';
import { getMultiplan } from '../lib/utils/get-multiplan';

type DisclamersType = 'PERSONAL_INFO' | 'PERSONAL_INFO_ONBOARDING' | 'SCHEDULE_A_CALL';

export const getDisclamers = (type: DisclamersType, data?: {maOrgCount: string, maPlansCount: string}, submitButtonLabel = 'Submit', includeAiVoiceCalls = false): React.ReactNode => {
  const getMedicareDisclamer = (children: ReactNode, multiplan = getMultiplan()): React.ReactNode => (
    <>
      By submitting my phone number and personal information above and clicking ‘{submitButtonLabel}’ above, I confirm that
      the phone number provided is my own, and I provide my express written consent to be contacted by
      a licensed insurance agent with CoverRight Insurance Services Inc at the phone
      number I have provided above regarding various Medicare products including Medicare Advantage Plans,
      Medicare Supplement Insurance (Medigap) Plans, Prescription Drug Plans and other marketing and informational
      content, through the use of text message, email and/or live, automated and pre-recorded telephone calls, prerecorded messages played when a connection is made, or prerecorded voicemail
      messages{includeAiVoiceCalls && <>, as well as AI generative voice calls for non-marketing and appointment scheduling purposes</>} even if my number is on a Do Not Call list. I further understand and agree that my communications
      with CoverRight Inc. are subject to CoverRight Inc.'s <Link href={'https://coverright.com/privacy/'}
                                                               target={'_blank'}>Privacy Policy</Link> and <Link
      href={'https://coverright.com/coverright-terms-of-use/'} target={'_blank'}>Terms of Use</Link>.
      <br />
      <br />
      This is a solicitation for insurance. Your information will be
      provided to a licensed insurance agent for future contact.
      <br />
      <br />
      I understand my consents to receive text messages and telephone
      calls are not required to receive services from CoverRight Inc.; I
      may instead reach CoverRight Inc. directly at +1 (888) 969-7667
      (TTY: 711) and I can revoke my consents at any time by emailing
      hello@coverright.com.
      <br />
      <br />
      CoverRight Insurance Services Inc. represents Medicare Advantage
      HMO, PPO and PFFS organizations that have a Medicare contract.
      Enrollment depends on the plan’s contract renewal with Medicare.
      <br />
      <br />
      {(data?.maOrgCount && data?.maPlansCount) ? <>
          We do not offer every plan available in your area. Currently we represent {data?.maOrgCount} organizations which
          offer {data?.maPlansCount} products in your area. Please contact Medicare.gov, 1–800–MEDICARE to get
          information on all of your options.
        </> :
        <>We do not offer every plan available in your area. Currently we represent 37 organizations which offer
          3,029 products in your area. Please contact Medicare.gov, 1-800-MEDICARE to get information on all of
          your options.</>}
      <br /><br />
      {children}
      {multiplan}
    </>
  )
  const disclamers = {
    'PERSONAL_INFO': getMedicareDisclamer(<>
      Enrollment in a plan may be limited to certain times of the year unless you qualify for a Special Enrollment
      Period or you are in your Medicare Initial Enrollment Period.
      <br /><br />
    </>),
    'PERSONAL_INFO_ONBOARDING': getMedicareDisclamer(<>
      Not all plans offer all of these benefits. Benefits may vary by carrier and location. Limitations and exclusions
      may apply.
      <br /><br />
      Enrollment in the described plan type may be limited to certain times of the year unless you qualify for a Special Enrollment
      Period or you are in your Medicare Initial Enrollment Period.
      <br /><br />
    </>, 'MULTIPLAN_COVERRIGHT_2027_HP_M'),
    'SCHEDULE_A_CALL': getMedicareDisclamer(<>
      For a complete list of available plans please contact 1-800-MEDICARE (1-800-633-4227). TTY/RTT users should call
      1-877-486-2048, 24 hours a day/7 days a week or consult Medicare.gov.
      <br /><br />
      Enrollment in the described plan type may be limited to certain times of the year unless you qualify for a
      Special Enrollment Period or you are in your Medicare Initial Enrollment Period.
      <br /><br />
      Medicare beneficiaries can file a complaint with the Centers for Medicare & Medicaid Services by calling
      1-800-MEDICARE 24 hours a day/7 days a week or using the medicare.gov site.
      <br /><br />
      Not all plans offer all of these benefits. Benefits may vary by carrier and location. Limitations and exclusions
      may apply.
      <br /><br />
    </>, ''),

  }

  return disclamers[type]
}
